if (!customElements.get('skn-brand-reveal')) {
  customElements.define('skn-brand-reveal', class extends HTMLElement {
    connectedCallback() {
      this.parts = Array.from(this.querySelectorAll('[data-reveal-part]'));
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!this.parts.length || this.motionPreference.matches || !('IntersectionObserver' in window)) return;
      const split = this.dataset.motion === 'split';
      this.parts.forEach((part, index) => {
        const offset = split && index === 1 ? '-115%' : '115%';
        part.style.transform = 'translateY(' + offset + ')';
        part.style.opacity = '0';
      });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.animations = this.parts.map((part, index) => {
          const offset = split && index === 1 ? '-115%' : '115%';
          const animation = part.animate([
            { transform: 'translateY(' + offset + ')', opacity: 0 },
            { transform: 'translateY(0)', opacity: 1 }
          ], {
            duration: split ? 1200 : 1000,
            delay: split ? 0 : index * 55,
            easing: 'cubic-bezier(0.16, 1, 0.3, 1)',
            fill: 'both'
          });
          animation.finished.then(() => {
            part.style.removeProperty('transform');
            part.style.removeProperty('opacity');
            animation.cancel();
          }).catch(() => {});
          return animation;
        });
      }, { threshold: 0.15 });
      this.observer.observe(this);
      this.onPreferenceChange = () => {
        if (!this.motionPreference.matches) return;
        this.observer.disconnect();
        this.animations?.forEach(animation => animation.cancel());
        this.parts.forEach(part => {
          part.style.removeProperty('transform');
          part.style.removeProperty('opacity');
        });
      };
      this.motionPreference.addEventListener('change', this.onPreferenceChange);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.onPreferenceChange) this.motionPreference.removeEventListener('change', this.onPreferenceChange);
    }
  });
}
